module.exports = __webpack_public_path__ + "static/media/step-03.f3037a5e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar/img/step-03.png
 ** module id = 2062
 ** module chunks = 0
 **/